import React, { useState, useEffect } from 'react';
import { format, parseISO } from 'date-fns';


export default function ComponentPayments({ currentInstitution}) {
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(currentInstitution.payments.length);


  useEffect(() => {
  }, [currentPage]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPayments = currentInstitution.payments.slice(indexOfFirstItem, indexOfLastItem);

  let countPayments = indexOfFirstItem + 1;

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6 pb-2">
        <div className="flex flex-col py-2 text-sm">
          <label>Payments</label>
        </div>
      </div>

{
loading ? (
              <div className='p-4'>Loading...</div>
            ) : 
            (
              <div className='overflow-x-auto'>
                <table className='min-w-full bg-white shadow-md rounded-lg overflow-hidden'>
                  {/* Table Header */}
                  <thead>
                    <tr>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        SN
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Institution
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Committed By
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Date
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Status
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Date Paid
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Teller Number
                      </th>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium uppercase text-white tracking-wider'>
                        Expiry Date
                      </th>
                      
                    </tr>
                  </thead>
                  {/* Table Body */}
                  <tbody>
                    {currentPayments.map((payment) => (
                      <tr key={payment.id} >
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                        {countPayments++} {/* {payment.id} */}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {payment.institution}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {payment.committed_by}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {/* {payment.date} */}
                          {/* {format(parseISO(payment.date), "yyyy-MM-dd HH:mm")}    */}
                          {payment.date.toString() != "0000-00-00" ?  format(parseISO(payment.date), "yyyy-MM-dd HH:mm") : '0000-00-00'}                       
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {payment.status}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {/* {payment.date_paid} */}
                          {/* {format(parseISO(payment.date_paid), "yyyy-MM-dd HH:mm")} */}
                          {payment.date_paid.toString() != "0000-00-00" ?  format(parseISO(payment.date_paid), "yyyy-MM-dd HH:mm") : '0000-00-00'}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {payment.teller_number}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {/* {payment.expiry_date} */}
                          {/* {format(parseISO(payment.expiry_date), "yyyy-MM-dd HH:mm")} */}
                          {payment.expiry_date.toString() != "0000-00-00" ?  format(parseISO(payment.expiry_date), "yyyy-MM-dd HH:mm") : '0000-00-00'}
                        </td>
                        
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
            }

{/* Pagination Controls */}
<div className="flex justify-center mt-4">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-4 py-2 mr-2 bg-gray-300 hover:bg-nbteGreen hover:text-white transition-colors duration-300"
          style={{width: '100px', borderRadius: '30px',}}
        >
          Previous
        </button>
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage)))}
          disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
          className="px-4 py-2 bg-gray-300 hover:bg-nbteGreen hover:text-white transition-colors duration-300"
          style={{width: '100px', borderRadius: '30px',}}
        >
          Next
        </button>
      </div>


    </div>
  );
}
